module.exports = __webpack_public_path__ + "attachment-download.df7924719668e3050ae1e9450bf5a6a8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/attachment-download.svg
// module id = 1126
// module chunks = 0